import {browserLocalStorage} from "core/browserStorage";

/**
 * Internal debug switches, read from localStorage so they can be flipped on any deployed build
 * without a rebuild. Not user-facing and not persisted anywhere else; absence (or any value other
 * than "1") means off — including outside a browser, where {@link browserLocalStorage} is null.
 */

/** Set to "1" in the console to bring the upload-speed readout back (removed from the default UI in ui#1840). */
export const UPLOAD_SPEED_DEBUG_KEY = "transferify.debug.uploadSpeed";

/** Whether the upload progress card shows the transfer speed beside the time left. */
export function uploadSpeedDebugEnabled(): boolean {
	return browserLocalStorage()?.getItem(UPLOAD_SPEED_DEBUG_KEY) === "1";
}
